import { tokenGetCode } from "@/api/platform";

const personalUrl = process.env.VUE_APP_PERSONAL_URL;
const isMobile = window.document.body.clientWidth - 1 < 1200 ? true : false;

export const setTitle = (title) => {
  document.title = title;
  var i = document.createElement("iframe");
  i.style.display = "none";
  i.onload = function () {
    setTimeout(function () {
      i.remove();
    }, 9);
  };
  document.body.appendChild(i);
};

export const isWechatBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf("micromessenger") != -1;
};

// 使用正则表达式去除所有HTML标签和&nbsp;
export const removeHtmlTags = (html) => {
  return html.replace(/<[^>]*>/g, "").replaceAll("&nbsp;", "");
};

// 个人中心play页面
export const toNewPlay = async (id, jspt_jxjy = false) => {
  const { results } = await tokenGetCode();
  let _back_url = encodeURIComponent(location.href);
  // 拼接query参数
  const queryList = [
    `_type=play`,
    `_code=${results}`,
    `_big_origin=PLATFORM_ID_${process.env.VUE_APP_PLATFORM_ID}`,
    `id=${id}`,
  ];
  // 只有布尔jspt_jxjy为true，才追加参数；false的时候不拼接这个字段
  if (jspt_jxjy) {
    queryList.push(`jspt_jxjy=true`);
  }
  queryList.push(`_back_url=${_back_url}`);
  const url = `${personalUrl}/auth?${queryList.join("&")}`;
  if (isMobile) {
    location.assign(url);
  } else {
    window.open(url);
  }
};

// 个人中心my页面
export const toMy = async () => {
  const { results } = await tokenGetCode();
  let _back_url = encodeURIComponent(location.href);
  const url = `${personalUrl}/auth?_code=${results}&isSimple=true&_big_origin=PLATFORM_ID_${process.env.VUE_APP_PLATFORM_ID}&_back_url=${_back_url}`;
  if (isMobile) {
    location.assign(url);
  } else {
    window.open(url);
  }
};

// 个人中心认证页面
export const toRenZheng = async () => {
  const { results } = await tokenGetCode();
  let _back_url = encodeURIComponent(location.href);
  const url = `${personalUrl}/auth?_type=renzheng&_code=${results}&isSimple=true&_big_origin=PLATFORM_ID_${process.env.VUE_APP_PLATFORM_ID}&_back_url=${_back_url}`;
  if (isMobile) {
    location.assign(url);
  } else {
    window.open(url);
  }
};

/**
 * 窗口大小变化检测函数
 * @param {Function} callback - 窗口大小变化时执行的回调函数
 * @param {number} [delay=200] - 防抖延迟时间(毫秒)
 * @returns {Function} 取消监听的函数
 */
export const onWindowResize = (callback, delay = 200) => {
  // 存储上一次的窗口尺寸
  let lastWidth = window.innerWidth;
  let lastHeight = window.innerHeight;

  // 防抖计时器
  let resizeTimer = null;

  // 实际的处理函数
  const handleResize = () => {
    const currentWidth = window.innerWidth;
    const currentHeight = window.innerHeight;

    // 只有当宽度或高度真正改变时才调用回调
    if (currentWidth !== lastWidth || currentHeight !== lastHeight) {
      const oldWidth = lastWidth;
      const oldHeight = lastHeight;
      callback({
        width: currentWidth,
        height: currentHeight,
        oldWidth,
        oldHeight,
      });

      // 再更新记录
      lastWidth = currentWidth;
      lastHeight = currentHeight;
    }
  };

  // 防抖处理后的函数
  const debouncedHandler = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, delay);
  };

  // 添加事件监听
  window.addEventListener("resize", debouncedHandler);

  // 返回一个取消监听的函数
  return () => {
    window.removeEventListener("resize", debouncedHandler);
    clearTimeout(resizeTimer);
  };
};

// 防抖
export function debounce(fn, delay) {
  // fn 是函数调用时的第一个函数参数
  let timer = null;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

// 去YMCenter通用大会授权页面
export const toYMCenterMeetingPayAuth = async (
  code,
  appId,
  source,
  bigOrigin,
  orderId,
  backurl
) => {
  // 拼接微信授权 重定向 到个人中心WechatAuth 需要的参数  bigOrigin orderId  backurl
  const params = `_code=${code}&_big_origin=${bigOrigin}&orderId=${orderId}&_return_url=${encodeURIComponent(
    backurl
  )}`;
  const wechat_redirect = encodeURIComponent(
    `${process.env.VUE_APP_CENTER_WECHATAUTH}?${params}`
  );
  location.replace(
    `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${wechat_redirect}&response_type=code&scope=snsapi_userinfo&state=${source}#wechat_redirect`
  );
};

export function formatSecToHms(videoTimeSec) {
  const total = Math.floor(Number(videoTimeSec) || 0);
  if (total <= 0) return "0s";

  const h = Math.floor(total / 3600);
  const min = Math.floor((total % 3600) / 60);
  const s = total % 60;

  const parts = [];
  if (h > 0) parts.push(`${h}h`);
  if (min > 0) parts.push(`${min}min`);
  if (s > 0) parts.push(`${s}s`);

  return parts.join("");
}
